export default {
  checkedBlocks: [],
  selectedBlockModel: null,
  impactedParks: ''
}
